import {Divider, theme, Typography} from 'antd';
import React from 'react';

interface IProps {
  label: string;
  value?: string;
}
const DetailListItem: React.FC<IProps> = (props) => {
  const {label, value = 'Not available'} = props;
  const {token}: any = theme.useToken();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
      <div
        style={{
          display: 'flex',
          flex: 0.5,
          padding: '16px 32px',
          backgroundColor: token.colorPrimaryBg,
        }}>
        <Typography.Text strong>{label}</Typography.Text>
      </div>
      <Divider type="vertical" style={{height: 'auto', alignSelf: 'stretch'}} />
      <Typography.Text style={{display: 'flex', flex: 2, marginLeft: 48}}>{value}</Typography.Text>
    </div>
  );
};

export default DetailListItem;
